import { render, staticRenderFns } from "./CommitmentsTab.vue?vue&type=template&id=1a0b6ed5&scoped=true&"
import script from "./CommitmentsTab.vue?vue&type=script&lang=js&"
export * from "./CommitmentsTab.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentsTab.vue?vue&type=style&index=0&id=1a0b6ed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b6ed5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0b6ed5')) {
      api.createRecord('1a0b6ed5', component.options)
    } else {
      api.reload('1a0b6ed5', component.options)
    }
    module.hot.accept("./CommitmentsTab.vue?vue&type=template&id=1a0b6ed5&scoped=true&", function () {
      api.rerender('1a0b6ed5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/tabs/CommitmentsTab.vue"
export default component.exports